import React from "react";
import { InputGroup, FormControl, Alert } from "react-bootstrap";

import { Footer } from "../components/include/Footer";
import Title from "../components/common/Title";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  isLoading,
  isError,
  isAuthenticated,
  isMessage,
  isData,
} from "../redux/selectors/authSelector";
import { verifyEmail } from "../redux/actions/authActions";
import { useNavigate } from "react-router-dom";
import { message } from "../redux/actions/toastActions";
import emailIcon from "../assets/Icons/email.svg";
import leftIcon from "../assets/Icons/leftArrow.svg";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import Logo from "../assets/Icons/Frame 476.png";
import "../styles/Login.scss";

const ForgotPassword = () => {
  const [username, setusername] = useState(
    process.env.NODE_ENV !== "production" ? "devadmin" : ""
  );
  const [password, setpassword] = useState(
    process.env.NODE_ENV !== "production" ? "123456" : ""
  );
  const [showPassword, setShowPassword] = useState(false);
  const [remember, setremember] = useState(false);
  // const [IPAddress, setIPAddress] = useState('')
  const loader = useSelector(isLoading);
  const Authenticated = useSelector(isAuthenticated);
  const Data = useSelector(isData);
  const loginMessage = useSelector(isMessage);
  const errorMsg = useSelector(isError);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onVerifyAction = async (event) => {
    // navigate("/verify");
    event.preventDefault();
    dispatch(
      verifyEmail({ email: username }, () => {
        navigate("/verify", { state: { email: username } }); // redirect after success
        
      })
    );
  };

//   useEffect(() => {
//     dispatch(loginClear());
//   }, []);

  // useEffect(() => {
  //   if (Authenticated) {
  //     navigate("/dashboard");
  //     dispatch(message(loginMessage));
  //   }
  // }, [Authenticated]);
  return (
    <>
      <Title name="Forgot Password" />
      {console.log("errorMsg =>", errorMsg)}
      <div
        className="account-pages  loginBackground"
        style={{ paddingTop: "14%" }}
      >
        <div className="container ">
          <div className="row justify-content-start">
            <div className="col-md-8 col-lg-6 col-xl-5">
              {errorMsg && <Alert variant="danger">{errorMsg}</Alert>}
              <div
                className="card overflow-hidden"
                style={{ backgroundColor: "white" }}
              >
                <div className="card-body pt-0">
                  <h3 className="text-center mt-4">
                    <a href="/" className="logo logo-admin">
                      <img src={Logo} height="100" alt="logo" className=" mb-4" style={{ width: "220px" }} />
                    </a>
                    <div className="d-flex align-items-center justify-content-start">
                      <img src={leftIcon} alt="logo" onClick={() => navigate(-1)} />{" "}
                      <h3 className="ps-5 ms-5 mb-0">Forgot Password</h3>
                    </div>
                    <p className="sub-title">
                      We will send you a verification code to your registered
                      email id.
                    </p>
                  </h3>
                  <div className="login-container">
                    <form
                      className="login-form"
                      action="/"
                        onSubmit={onVerifyAction}
                    >
                      <label>
                        Email ID<span className="required">*</span>
                      </label>
                      <div className="input-group">
                        <span className="icon">
                          <img src={emailIcon} />
                        </span>
                        <input
                          type="text"
                          value={username}
                          autoComplete="current-email"
                          onChange={(e) => setusername(e.target.value)}
                          placeholder="Enter Your Email ID"
                          required
                        />
                      </div>

                      <button
                        type="submit"
                        className="sign-in-button mb-3"
                        disabled={loader}
                      >
                        {loader ? "Please wait..." : "Send Verification Code"}
                      </button>
                    </form>
                  </div>
                </div>
              </div>
              {/* <div className="mt-5 text-center">
                <Footer />
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
